export default __webpack_public_path__ + "static/media/planetm03.5c5340a3.png";